import {
    FETCH_ALL_EHR_REQUEST,
    FETCH_ALL_EHR_SUCCESS,
    FETCH_ALL_EHR_FAILURE
} from '../electronic-health-records/ehrActions.js';

// Initial State
const initialState = {
    data: {},
    loading: false,
    error: null
};

// Reducer
const ehrReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_EHR_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_ALL_EHR_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };

        case FETCH_ALL_EHR_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default ehrReducer;
